import usePrivateAxios from '@/common/api/usePrivateAxios'
import { removeSpecialCharacters } from '@/common/utils/unFormatters'
import { PublicCompanyLeadsFunnelUpdateContactValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';

interface UseUpdatePublicCompanyLeadContact {
  contactId?: string
  publicCompanyLeadId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: any) => void
}

export const useUpdatePublicCompanyLeadContact = ({
  contactId,
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContact) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContact'],
    mutationFn: (data: PublicCompanyLeadsFunnelUpdateContactValidationSchema) => {
      const lead = {
        contacts_attributes: [
          {
            ...data.contacts,
            phone_attributes: {
              number: data.contacts.phone?.number ? removeSpecialCharacters(data.contacts.phone.number) : '',
            },
            id: contactId,
            cpf: data.contacts.cpf ? removeSpecialCharacters(data.contacts.cpf) : null,
            documents_attributes: data.contacts.documents.map((document) => {
              if (document?.checked) {
                const doc = {
                  ...document,
                  cnh: document.cnh ? removeSpecialCharacters(document.cnh) : null,
                }

                delete doc.type

                return doc
              }

              return null
            }),
          },
        ],
      }

      return privateAxios.putForm(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
